import { useState } from 'react';

export default function Header() {
const [open, setOpen] = useState(false);
  return (
    <header className="z-50 App-header">
      <div className="max-w-7xl mx-auto px-6 py-2 flex items-center justify-between">
        
        {/* Left — Logo */}
        <a href="/" className="flex items-center gap-3 group">
          <img
            src="/logo-icon.png"
            alt="LoanPulse"
            className="h-12 w-12 transition-transform group-hover:scale-105"
          />
          <span className="font-bold text-2xl text-[var(--primary)] tracking-tight">
            LoanPulse
          </span>
        </a>

        {/* Center Nav (Desktop) */}
        <nav className="hidden md:flex items-center gap-10 text-[17px] font-bold text-[var(--primary)]">
          <a href="#features" className="hover:text-[var(--primary)] transition">Features</a>
          <a href="#how" className="hover:text-[var(--lp-primary)] transition">How it works</a>
          <a href="#pricing" className="hover:text-[var(--lp-primary)] transition">Pricing</a>
          <a
            href="#contact"
            className="px-4 py-2 rounded-lg border border-[var(--lp-primary)] text-[var(--lp-primary)] hover:bg-[var(--primary)] hover:text-white transition"
          >
            Contact
          </a>
        </nav>

        {/* Mobile Menu Icon */}
          <button
            className="md:hidden text-2xl"
            aria-controls="mobile-menu"
            aria-expanded={open}
            onClick={() => setOpen(v => !v)}
          >
            ☰
          </button>
      </div>
      {/* Mobile panel */}
        {open && (
          <div id="mobile-menu" className="md:hidden pb-4">
            <div className="flex flex-col gap-3">
              <a href="#features" onClick={() => setOpen(false)} className="block text-gray-700">Features</a>
              <a href="#how" onClick={() => setOpen(false)} className="block text-gray-700">How it works</a>
              <a href="#pricing" onClick={() => setOpen(false)} className="block text-gray-700">Pricing</a>
              <a href="#contact" onClick={() => setOpen(false)} className="block text-primary">Contact</a>
            </div>
          </div>
        )}
    </header>
  );
}
